<template>
  <StyledExpirationBar v-if="showExpiration">
    <div class="status-bar">
      <div class="status-bar__label">{{ $t('remains') }}</div>
      <div class="status-bar__step status-bar__step--remains">
        {{ expires }}
      </div>
    </div>
  </StyledExpirationBar>
</template>

<script>
import { mapState } from 'vuex';
import styled from 'vue-styled-components';
import expirationDateHandler from '@/mixins/expirationDateHandler';

const StyledStatusBar = styled.section`
  background-color: var(--primary);
  color: var(--on_primary_color);
  z-index: 105;
  position: relative;
  background-color: var(--primary_font_color);
  padding: 20px;
  .status-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__step {
      &--remains {
        font-size: 0.8em;
      }
    }
  }
`;

const StyledExpirationBar = styled(StyledStatusBar)`
  padding: 5px 20px;
  background-color: var(--primary_variant);
  .status-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8em;

    &__step {
      &--remains {
        font-size: 0.8em;
      }
    }
  }
`;

export default {
  components: {
    StyledExpirationBar,
  },
  mixins: [expirationDateHandler],

  async created() {
    const { expires, display } = this.invoiceInitialData || {};
    const hide_lifetime_counter = (display || {}).hide_lifetime_counter;
    const showTimer = !hide_lifetime_counter;

    if (expires && showTimer) {
      this.showExpiration = true;
      try {
        await this.validateDate();
        this.timer = setInterval(() => {
          this.countDown();
        }, 1000);
      } catch (e) {
        clearInterval(this.timer);
        this.setGlobalError(e);
      }
    }
  },

  computed: {
    ...mapState(['statusBar', 'invoiceInitialData']),
  },
};
</script>
